<template>
  <div>
    <MenuCount_Storage/>
    <Warehouse_count/>
  </div>
</template>

<script>
import MenuCount_Storage from "@/components/admin/stock/count_storage/menucount_storage/MenuCount_Storage";
import Warehouse_count from "@/components/admin/stock/count_storage/Warehouse_count";
export default {
  name: "WarehouseCount",
  components: {
    Warehouse_count,
    MenuCount_Storage
  },
}
</script>

<style scoped>

</style>
